<div class="flex flex-col overflow-hidden">
  @if (canAddAttachments) {
    <app-file-drag-drop
      (selectedFiles)="_addNewAttachments($event)" />
  }

  <app-annotation-attachment-list
    [attachments]="downloadableAttachments"
    [actionsEnabled]="mode === 'edit'"
    class="w-full mt-4"
    (removeAttachment)="_removeAttachment($event)"  />
</div>
